//https://www.telerik.com/kendo-react-ui/components/scheduler/customization/form/editor/
/* eslint-disable */

import React, { useState, useEffect, useMemo } from "react";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, NumericTextBox } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { utility } from "../../../framework/utility/utilityProvider";
import * as API from '../../../framework/API/api';
import { TimePickerWithFormat } from "../../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import { DropdownWithDefaultValue } from "../../../framework/forms/helpercomponents/dropdown/DropdownWithDefaultValue";
import { ENTITYNAME, FrameEquivalentOfMilliSecond, MEDIACATEGORIES, MODULE, TOAST_TYPES } from "../../../framework/constant/constant";
import { useTranslation } from "../../../locale/useTranslation";
import { PlanningHelper } from "../helper/PlanningHelper";
import BossDialog from "../../../components/BossDialog";
import ToastNotification from "../../../components/ToastNotification";
import { ConfirmAlert } from "../../../ConfirmAlert";

const PlanningEditFormWithSlot = (props) => {
  const [channels, setChannels] = useState([]);
  const [segments, setSegments] = useState([]);
  const [isEpisode, setIsEpisode] = useState(props.dataItem?.mediaEpisode?.MediaCategory?.SID == MEDIACATEGORIES.Episode);
  const [isOpenFromSchedule, setIsOpenFromSchedule] = useState(props.isOpenFromSchedule ?? false);
  const lang = useTranslation();

  const [dataItem, setDataItem] = useState(props.dataItem);

  const initialValues = useMemo(() => ({
    ...props.dataItem,
    Title: props.dataItem?.mediaEpisode?.Title ?? props.dataItem?.Title ?? "",
    Description: props.dataItem?.mediaEpisode?.Description ?? props.dataItem?.Description ?? "",
    ActualDuration: utility.convertMilisecondsToStringWithFrames(props.dataItem?.ActualDuration ?? 0),
    NominalDuration: utility.convertMilisecondsToStringWithFrames(props.dataItem?.NominalDuration ?? 0),
    customDuration: props.dataItem?.customDuration ? utility.convertMilisecondsToStringWithFrames(props.dataItem?.customDuration ?? 0) : null,
    SeasonNumber: props.dataItem?.mediaEpisode?.SeasonNumber ?? 1,
    EpisodeNumber: props.dataItem?.mediaEpisode?.EpisodeNumber ?? 1,

    SlotDateLocal: new Date(utility.datetimeFormat(PlanningHelper.getGMTSlotDateTime(props.dataItem?.Channel, props.dataItem?.SlotDateTime, true))),
    SlotTimeLocal: utility.convertMilisecondsToStringWithFrames(PlanningHelper.getGMTSlotDateTime(props.dataItem?.Channel, props.dataItem?.SlotDateTime, true)),

    customTitle: props.dataItem?.customTitle ?? "",
    SlotSynopsis: props.dataItem?.SlotSynopsis ?? "",

    selectedSegment: props.dataItem?.Segment_id
  }), [props.dataItem]);

  useEffect(() => {
    setIsEpisode(props.dataItem?.mediaEpisode?.MediaCategory?.SID == MEDIACATEGORIES.Episode);
    loadMaster();
  }, [props.dataItem]);

  async function loadMaster() {
    var channelsData = await API.getDataLookup(ENTITYNAME.Channel);
    var segmentsData = props.dataItem?.mediaEpisode?.SID ? await API.getData(ENTITYNAME.MediaEpisodeSegment, {
      query: ['MediaEpisodeSID', '=', props.dataItem?.mediaEpisode?.SID],
    }) : { data: [] };

    setChannels(channelsData.data);
    let validSegments = PlanningHelper.getValidSegmentsByChannel(segmentsData.data || [], props.dataItem?.Channel);
    setSegments(validSegments);
  }

  const onChange = (e) => {

    if(e.target.name == "customDuration"){
      setDataItem({ ...dataItem, customDuration: utility.convertStringWithFramesToMilliseconds(e.target.value) });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  }

  const handleSubmit = async (event) => {
    let dayStartTime = PlanningHelper.getDayStartTime([props.dataItem.Channel]);

    let slotDateLocal = event.SlotDateLocal;

    // if(dayStartTime > 0 && utility.convertStringWithFramesToMilliseconds(event.SlotTimeLocal) < dayStartTime){
    //   //ADD ONE DAY
    //   //slotDateLocal = new Date(new Date(event.SlotDateLocal).setDate(new Date(event.SlotDateLocal).getDate() + 1));
    // }

    const [hours, minutes, seconds, frames] = event.SlotTimeLocal.replaceAll('_', '0').split(':');
    var slotDate = new Date(slotDateLocal).setHours(parseInt(hours), parseInt(minutes), parseInt(seconds), parseInt(frames) * FrameEquivalentOfMilliSecond);
    var newSlotDateTime = utility.getLocalDateTimeToUtcMiliseconds(new Date(slotDate));

    let updatedData = {
      SID: event.SID,
      _id: event._id,
      ScheduleDate: props?.module == MODULE.PLANNING ?
        PlanningHelper.getGMTSlotDateTime(props.dataItem.Channel, newSlotDateTime) :
        PlanningHelper.getGMTSlotDateTime(props.dataItem.Channel, utility.getLocalDateTimeToUtcMiliseconds(event.SlotDateLocal)),

      SlotDateTime: PlanningHelper.getGMTSlotDateTime(props.dataItem.Channel, newSlotDateTime),
      EndSlotDateTime: PlanningHelper.getGMTSlotDateTime(props.dataItem.Channel, newSlotDateTime + event.Duration),
      Segment_id: event.selectedSegment?._id ?? props.dataItem.Segment_id,
      customDuration: typeof event.customDuration === 'string'
        ? utility.convertStringWithFramesToMilliseconds(event.customDuration)
        : (event.customDuration ?? dataItem.customDuration ?? props.dataItem?.customDuration),
      segment: segments.find((seg) => seg._id == (event.selectedSegment?._id ?? props.dataItem.Segment_id)) ?? props.dataItem.segment,
      customTitle: event.customTitle,
      SlotSynopsis: event.SlotSynopsis,
      Description: event.SlotSynopsis ?? event.Description
    };

    const targetChannelSID = props.dataItem?.Channel?.SID ?? props.dataItem?.ChannelSID ?? props.dataItem?.Channel;
    const matchingSlot = PlanningHelper.getMatchingCustomSlot(
      updatedData.SlotDateTime,
      null,
      targetChannelSID,
      props.customSlots || []
    );

    const originalSlot = props.dataItem?.ProgramScheduleSlot;
    const wasInCustomSlot = Boolean(originalSlot && originalSlot._id);
    const isMovingOutOfCustomSlot = wasInCustomSlot && (
      !matchingSlot ||
      String(matchingSlot._id) !== String(originalSlot._id)
    );

    const executeSave = async (dataToSave) => {
      const validDayPart = await PlanningHelper.getValidDayPartForTimeBand(dataToSave);

      let res = props.module == MODULE.SCHEDULING ? { success: true } : await API.savePlanning(dataToSave, segments, false, false, 0, validDayPart);

      if (res.success) {
        dataToSave.NominalDuration = (typeof event.NominalDuration == 'string' ? utility.convertStringWithFramesToMilliseconds(event.NominalDuration) : event.NominalDuration);
        dataToSave.ActualDuration = (typeof event.ActualDuration == 'string' ? utility.convertStringWithFramesToMilliseconds(event.ActualDuration) : event.ActualDuration);

        if (dataToSave.Segment_id) {
          let segment = segments.find((seg) => seg._id == dataToSave.Segment_id);
          if (segment) {
            dataToSave.ActualDuration = segment.ActualDuration;
          }
        }

        props.onUpdateFromPlanningEditForm(dataToSave);
        props.onClose();
      } else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      }
    };

    if (isMovingOutOfCustomSlot) {
      const slotName = originalSlot?.Description || "Custom Slot";
      ConfirmAlert(
        async () => {
          updatedData.ProgramScheduleSlot = matchingSlot ? {
            _id: matchingSlot._id?.toString() || matchingSlot._id,
            Description: matchingSlot.Description || ""
          } : null;
          await executeSave(updatedData);
        },
        () => {
          // Abort save when user chooses not to detach
        },
        "Detach Slot",
        `Do you want to detach the planning item from this slot (${slotName})?`
      );
    } else {
      updatedData.ProgramScheduleSlot = matchingSlot ? {
        _id: matchingSlot._id?.toString() || matchingSlot._id,
        Description: matchingSlot.Description || ""
      } : (props.dataItem?.ProgramScheduleSlot ?? null);
      await executeSave(updatedData);
    }
  };

  return (
    <BossDialog
      title={initialValues.Title}
      onClose={props.onClose}
      width={1000}
    >
      <Form
        key={props.dataItem._id}
        onSubmit={handleSubmit}
        initialValues={initialValues}
        render={(formRenderProps) => (
          <FormElement>
            <div className="row">
              <div className="col-10">
                <fieldset>
                  <div className="mb-2">
                    <Field
                      name={"mediaEpisode.AssetId"}
                      component={Input}
                      label={lang.house_number_label}
                      disabled
                    />
                  </div>
                  <div className="row mb-2">
                    <div className="col-6">
                      <Field name={"Title"} component={Input} label={lang.title_label} disabled />
                    </div>

                    <div className="col-6">
                      <Field
                        name={"customTitle"}
                        component={Input}
                        label={lang.custom_title_label}
                      />
                    </div>

                    <div className="col-6">
                      <Field name={"Description"} component={Input} label={lang.description_label} disabled />
                    </div>

                    <div className="col-6">
                      <Field
                        name={"SlotSynopsis"}
                        component={Input}
                        label={lang.custom_description_label}
                      />
                    </div>

                    {isEpisode && <div className="col-3">
                      <Field
                        name={"SeasonNumber"}
                        component={NumericTextBox}
                        label={lang.season_no_label}
                        disabled
                      />
                    </div>}
                    {isEpisode && <div className="col-3">
                      <Field
                        name={"EpisodeNumber"}
                        component={NumericTextBox}
                        label={lang.episode_number_label}
                        disabled
                      />
                    </div>}
                  </div>
                  {isEpisode && <div className="mb-2">
                    <Field
                      name={"mediaEpisode.EpisodeTitle"}
                      component={Input}
                      label={lang.episode_title_label}
                      disabled
                    />
                  </div>}
                  <div className="row mb-2">
                    <div className="col-8">
                      <Field
                        name={"mediaEpisode.MediaCategory.Description"}
                        component={Input}
                        label={lang.category_type_label}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-3">
                      <Field
                        name={"ExhibitionNumber"}
                        component={NumericTextBox}
                        label={lang.exhibition_label}
                        disabled
                      />
                    </div>
                    <div className="col-3">
                      <Field
                        name={"RepeatNumber"}
                        component={NumericTextBox}
                        label={lang.repeat_label}
                        disabled
                      />
                    </div>
                    <div className="col-6">
                      <Field
                        name={"ChannelSID"}
                        component={DropdownWithDefaultValue}
                        data={channels}
                        datakey="SID"
                        textField={'FullChannelName'}
                        label={lang.channel_label}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-6">
                      <Field
                        name={"SlotDateLocal"}
                        component={DatePicker}
                        placeholder={""}
                        label={"Slot Date"}
                      />
                    </div>
                    <div className="col-6">
                      <Field
                        name={"SlotTimeLocal"}
                        component={TimePickerWithFormat}
                        label={lang.slot_time_label}
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-3">
                      <Field
                        name={"ActualDuration"}
                        component={TimePickerWithFormat}
                        label={lang.actual_duration_label}
                        disabled={isOpenFromSchedule}
                      />
                    </div>

                    <div className="col-3">
                      <Field
                        name={"NominalDuration"}
                        component={TimePickerWithFormat}
                        label={lang.nominal_duration_label}
                        disabled={isOpenFromSchedule}
                      />
                    </div>

                    <div className="col-3">
                      <Field
                        name={"customDuration"}
                        component={TimePickerWithFormat}
                        label={'Custom Duration'}
                      />
                    </div>

                    <div className="col-3 text-right">
                      <Field
                        name={"selectedSegment"}
                        component={DropdownWithDefaultValue}
                        data={segments}
                        textField={"SegmentType.Description"}
                        label={lang.segments_label}
                        datakey="_id"
                        disabled={isOpenFromSchedule}
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="col-2">
                <button
                  type={"submit"}
                  className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary col-12"
                >
                  {lang.save_button_text}
                </button>
                <button
                  style={{ marginTop: "5px" }}
                  className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base col-12"
                  onClick={() => {
                    props.onClose();
                  }}
                >
                  {lang.cancel_button_text}
                </button>
              </div>
            </div>
          </FormElement>
        )}
      />
    </BossDialog>
  );
};

export default PlanningEditFormWithSlot;
